import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuen3saiKara: BlogMetaData = {
  title: '保育園は3歳から入れる？入りやすさの目安と幼稚園・認定こども園との違い',
  description:
    '保育園は3歳からでも入れる？入りやすさは自治体・園・年度で異なります。認可保育所・認定こども園・幼稚園＋預かり・認可外の違い、3歳児クラスの空きの仕組み、空き確認から見学・申込までの動き方を園長が整理します。',
  thumbnailUrl: '/img/blog-hoikuen-3sai-kara.webp',
  filePath: buildBlogFilePath('hoikuen-3sai-kara'),
  category: BLOG_CATEGORY.NURSERY,
};
